import { FormControls } from '../../../../components/FormUtilities'
import Panel, { PanelBody, PanelHeader } from '../../../../components/Panel'
import Fields from './Fields'
import Button from '../../../../components/Button'
import useSubmitProduct from '../../useSubmitProduct'
import { storagePage } from '../../storage'

export default function ConsumablesInfo() {
    const submit = useSubmitProduct()
    return (
        <Panel mode="form">
            <PanelHeader title="Informacion de Consumibles">
                {storagePage.mode === 'edition' && (
                    <Button size="sm" color="accent" onClick={() => submit()}>
                        Guardar
                    </Button>
                )}
            </PanelHeader>
            <PanelBody>
                <FormControls>
                    <Fields />
                </FormControls>
            </PanelBody>
        </Panel>
    )
}
